<template>
  <div class="sjf-order">
    <div class="detail">
      <span class="title">宴席原始数据</span>
      <div class="item" v-for="field in fields">
        <span class="label">{{ field.label }}</span>
        <span class="value">{{ formatValue(field, sjfOrderDetail) }}</span>
      </div>
    </div>
    <div class="detail remark" v-if="sjfOrderDetail.task_update_record">
      <span class="title">订单备注要求</span>
      <div v-html="`${sjfOrderDetail.task_update_record.content}`"></div>
      <div v-if="sjfOrderDetail.task_update_record.photo && sjfOrderDetail.task_update_record.photo.length > 0"
           class="question-review">
        <span class="title">图片</span>
        <answer-file-list
          :question="{title: ''}"
          :question-index="0"
          disabled
          :files="sjfOrderDetail.task_update_record.photo.map(it => ({src:it}))"
          type="photo"/>
      </div>

      <div v-if="sjfOrderDetail.task_update_record.instruct_video" class="question-review">
        <span class="title">视频</span>
        <answer-file-list
          :question="{title: ''}"
          :question-index="0"
          disabled
          :files="[{
            cover: sjfOrderDetail.task_update_record.instruct_video_cover,
            src: sjfOrderDetail.task_update_record.instruct_video
          }]"
          type="video"/>
      </div>

      <div v-if="sjfOrderDetail.task_update_record.instruct_audio" class="question-review">
        <span class="title">音频</span>
        <answer-file-list
          :question="{title: ''}"
          :question-index="0"
          disabled
          :files="[{src: sjfOrderDetail.task_update_record.instruct_audio}]"
          type="record"/>
      </div>

    </div>
  </div>
</template>

<script>
import AnswerFileList from '@views/question-review/packages/AnswerFileList'
import '@views/question-review/question-review.scss'
export default {
  components: { AnswerFileList },
  inject: ['page'],
  data () {
    return {
      yxhBanquetType: {
        1: '婚宴',
        2: '生日宴',
        3: '商务宴',
        4: '升学宴',
        5: '其他',
        6: '小桌宴',
        7: '白事',
        8: '刮卡升学宴',
        9: '活动宴会',
        10: '乔迁宴'
      },
      yxhBanquetCategory: {
        0: '午宴',
        1: '晚宴',
      },
      yxhBanquetAddressType: {
        1: '酒店地址',
        2: '非酒店地址',
      },

      fields: [
        {
          label: '宴席地址',
          key: 'yxh__banquetAddress',
        },
        {
          label: '宴席详细地址',
          key: 'yxh__banquetAddressDetail',
        },
        {
          label: '宴席时间',
          key: 'yxh__banquetDate',
        },
        {
          label: '宴席类别',
          key: 'yxh__banquetCategory',
          formatter: detail => this.yxhBanquetCategory[detail.yxh__banquetCategory],
        },
        {
          label: '宴席类型',
          key: 'yxh__banquetType',
          formatter: detail => this.yxhBanquetType[detail.yxh__banquetType],
        },
        {
          label: '宴席桌数',
          key: 'yxh__tableNum',
        },
        {
          label: '用酒数量(瓶)',
          key: 'yxh__wineNum',
        },
        {
          label: '用酒种类',
          key: 'yxh__productName',
        },
        {
          label: '消费者姓名',
          key: 'yxh__customerName',
        },
        {
          label: '是否推单',
          key: 'yxh__hasPushOrder',
          formatter: detail => detail.yxh__hasPushOrder === 1 ? '是' : '否',
        },
        {
          label: '是否增值服务',
          key: 'yxh__hasValueAdded',
          formatter: detail => detail.yxh__hasValueAdded === 1 ? '是' : '否',
        },
        {
          label: '宴席地址类型',
          key: 'yxh__banquetAddressType',
          formatter: detail => this.yxhBanquetAddressType[detail.yxh__banquetAddressType]
        },
        {
          label: '酒店名称',
          key: 'yxh__subDistrictName',
        },
        {
          label: '酒店楼层',
          key: 'yxh__buildingName',
        },
        {
          label: '订单备注',
          key: 'yxh__remark',
        },
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      sjfOrderDetail: state => state.orderReview.sjfOrderDetail,
    }),
  },
  methods: {
    formatValue (field, form) {
      const val = field.formatter ? field.formatter(form) : this.getByPath(form, field.key)
      return (val === null || val === undefined || val === '') ? '-' : val
    },
    getByPath (obj, path) {
      return _.get(obj, path)
    },
  }
}
</script>

<style scoped>
.sjf-order {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.detail {
  background-color: #ecf5ff;
  padding: 8px;
  border-radius: 6px;
}
.remark {
  background-color: #f4f4f5;
}
.title {
  display: inline-block;
  margin-top: 12px;
  font-size: 14px;
  font-weight: bold;
}
.item {
  margin: 8px 0;
  display: flex;
  flex-direction: row;
}
.label {
  display: inline-block;
  font-size: 14px;
  width: 110px;
  color: #666;
}

.value {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.images {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/SJFOrderDetail.vue